
import Vue from "vue"
import KioskSubscription from "@/components/subscription/KioskSubscription.vue"

export default Vue.extend({
  components: {
    KioskSubscription,
  },
  beforeCreate() {
    this.$vuetify.theme.dark = false // we force light them on this view
  },
  created() {
    document.title = this.$vuetify.lang.t("$vuetify.tab_titles.kiosk_subscription")
  },
  data: () => ({
    show: true
  })
})
